export default "__VITE_ASSET__CU9gPq3u__"